import { inject } from "vue";

export function checkOnlineStatus(notifyMethod, notifyText) {
    if (!navigator.onLine) {
        notifyMethod({
            group: "error",
            text: notifyText,
        }, 8000);
        return false;
    }
    return true;
}

export function setT(translationKeys) {
    const lang = inject('lang');
    return translationKeys[(lang as any).userLangFull]
}

export function getLang(type = null) {
    const lang = inject('lang');
    return type === "full" ? (lang as any).userLangFull : (lang as any).userLang
}